<template>
  <div class="debug-overlay">
    <h1 class="text-center mt-5">Debug mode!</h1>
    <div class="text-center">
      <c-button color="primary" @click="$emit('close')">Close</c-button>
    </div>
    <img src="https://koalaboss-public-assets.s3-ap-southeast-2.amazonaws.com/app/debug-mode.gif"/>
  </div>
</template>
<script>
export default {
  name: 'DebugMode',
};
</script>
<style lang="scss">
.debug-overlay {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: #5eceb3;
  z-index: 1060;
  img {
    width: 50%;
    margin: 50px auto;
    display: block;
  }
}
</style>
